export const BUSINESS = {
  name: "Moe's Dump & Junk",
  phone: "(727) 945-4778",
  phoneRaw: "7279454778",
  website: "moesdumpandjunk.com",
  county: "Pinellas County",
  hours: "Open 6 AM – 6 PM",
  rating: "5.0",
  reviewCount: 46,
};

export const REAL = {
  fleet: "https://customer-assets-lqy194kg.emergentagent.net/job_dumpster-rental-4/artifacts/rczj0ivp_IMG_2862.jpeg",
  cardboardLoad: "https://customer-assets-lqy194kg.emergentagent.net/job_dumpster-rental-4/artifacts/rzhhx3h2_IMG_2861.jpeg",
  mattressLoad: "https://customer-assets-lqy194kg.emergentagent.net/job_dumpster-rental-4/artifacts/n9o7cplo_IMG_2860.jpeg",
  flyer: "https://customer-assets-lqy194kg.emergentagent.net/job_dumpster-rental-4/artifacts/9bwpeqxj_IMG_2859.jpeg",
};

export const GALLERY = [
  { src: REAL.fleet, caption: "The fleet, ready to roll", tall: false },
  { src: REAL.cardboardLoad, caption: "Loaded & tarped for haul-off", tall: true },
  { src: REAL.mattressLoad, caption: "Mattresses, furniture — gone same day", tall: true },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1711618732595-0c517e08d40c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  dumpsterIndustrial: "https://images.unsplash.com/photo-1662826479139-c02f439fa49f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  constructionDumpster: "https://images.unsplash.com/photo-1775157478624-4f9f718dcb3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  truckDumping: "https://images.unsplash.com/photo-1773852184074-e7ecb1dd3665?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  excavatorRubble: "https://images.unsplash.com/photo-1711618732376-416cf6af54f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  worker: "https://images.unsplash.com/photo-1610141160723-d2d346e73766?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  debris: "https://images.unsplash.com/photo-1769053144989-5a8804b98917?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  tampaBay: "https://images.unsplash.com/photo-1653839566839-26c14bdbd570?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const SERVICES = [
  {
    tag: "01",
    title: "Roll-Off Dumpster Rental",
    desc: "Driveway-friendly roll-off containers dropped and picked up on your schedule. Perfect for renovations, roofing and cleanouts.",
    img: IMAGES.constructionDumpster,
  },
  {
    tag: "02",
    title: "Full-Service Junk Removal",
    desc: "We load it, haul it and sweep up. Furniture, appliances, yard waste and estate cleanouts — you point, we lift.",
    img: IMAGES.worker,
  },
  {
    tag: "03",
    title: "Construction Debris Hauling",
    desc: "Concrete, drywall, lumber and jobsite waste removed fast so your crew keeps moving.",
    img: IMAGES.excavatorRubble,
  },
  {
    tag: "04",
    title: "Same-Day Waste Pickup",
    desc: "Call before noon and we'll do our best to be there today. Reliable, on-time, Pinellas-local service.",
    img: IMAGES.truckDumping,
  },
];

export const MANIFESTO = [
  { num: "01", title: "FAST", desc: "Same-day service across Pinellas. Book in the morning, gone by evening." },
  { num: "02", title: "RELIABLE", desc: "5.0 stars from 46 neighbors. We show up when we say we will." },
  { num: "03", title: "CLEAN", desc: "We sweep the spot before we leave. No trace, no hassle, no surprises." },
];

export const PRICING = [
  { size: "First 24 Hours", best: "Drop-off & pickup included", price: "$100" },
  { size: "Each Additional Day", best: "Keep it as long as you need", price: "$35" },
  { size: "Dump Fees", best: "You pay only the landfill weight fee — no markup", price: "At cost" },
];

export const AREAS = [
  "Clearwater", "St. Petersburg", "Largo", "Pinellas Park", "Dunedin",
  "Palm Harbor", "Seminole", "Tarpon Springs", "Safety Harbor", "Oldsmar",
  "Gulfport", "Treasure Island", "Madeira Beach", "Belleair",
];

export const REVIEWS = [
  { name: "Danielle R.", text: "Moe dropped the dumpster same day and picked it up the second I called. Fair price, zero games. Rare these days." },
  { name: "Carlos M.", text: "Cleared out my dad's garage in under two hours. Polite, fast and left the driveway spotless. Hiring again." },
  { name: "Jenna P.", text: "Best junk removal in Pinellas, hands down. Quoted me honest, showed up early, done deal." },
];

export const SERVICE_OPTIONS = [
  "Roll-Off Dumpster Rental",
  "Full-Service Junk Removal",
  "Construction Debris Hauling",
  "Same-Day Waste Pickup",
];

export const SIZE_OPTIONS = ["10 Yard", "15 Yard", "20 Yard", "Not sure yet"];
